// Utilities
import axios from "axios";
import * as R from "ramda";
// Types
import type { AxiosInstance } from "axios";
import type { HttpClient } from "src/VirtualOMS/types/http";

export type BaseResponse<T = any> = Promise<T & HttpClient.BaseApiResponse>;

interface Config {
  suffix?: string;
}
/**
 * A HTTP service which created by Axios instance creator
 *
 * @abstract
 */
abstract class BaseAPI {
  protected httpService: AxiosInstance;

  protected constructor({ suffix }: Config) {
    // create a new instance of the Axios with custom config.
    this.httpService = axios.create({
      baseURL: `https://virtualoms.payaalgorithm.ir${
        suffix ? `/${suffix}` : ""
      }`,
    });

    this.requestInterceptors();
    this.responseInterceptors();
  }

  private requestInterceptors() {
    this.httpService.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  private responseInterceptors() {
    // Intercept responses before they are handled by then or catch.
    this.httpService.interceptors.response.use(
      (response) => R.pathOr(response, ["data"])(response),
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}

export default BaseAPI;
